// @flow
import { COMPANY_BACKEND_URL } from "../../Constants/Global/apiConstants";
import axios from "axios";
import { getPhoneNumberUnmasked } from "../../Utilities/Helpers/InputMaskHelpers";

function getCompanyStringByType(type: string): string {
  if (type === "C") {
    return "customer";
  }
  if (type === "P") {
    return "partner";
  }
  return "";
}

export function companyRegisterFormSubmit(formElements: Object, type: string, request_secret: string): Object {
  const companyType = getCompanyStringByType(type);
  const apiSecrets = { "request_secret": request_secret };

  formElements.phone = getPhoneNumberUnmasked(formElements.phone);

  return axios.create({
    method: "post",
    headers: { "Content-Type": "application/json", "api-secrets": JSON.stringify(apiSecrets) },
    url: `${COMPANY_BACKEND_URL}/${companyType}/create`,
    data: formElements
  });
}



// WEBPACK FOOTER //
// ./src/Api/PublicAccountPages/companyregister.js